import React from 'react';
import { FadeInView } from '../ui/FadeInView';
import { CTAButton } from '../ui/CTAButton';
export function SolutionSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#FAF7F2] text-center relative overflow-hidden" data-id="element-189">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-190">
        <FadeInView data-id="element-191">
          <div className="inline-block bg-[#2D5016]/10 text-[#2D5016] font-medium px-6 py-2 rounded-full mb-8 text-sm tracking-widest uppercase" data-id="element-192">
            La Solución
          </div>

          <h2 className="text-5xl md:text-7xl font-bold text-[#1B4332] mb-8 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-193">
            Adelgaza con Airfryer
          </h2>

          <p className="text-xl md:text-2xl text-[#2D5016]/80 mb-10 font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-194">
            Un sistema diseñado para que puedas:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left max-w-3xl mx-auto mb-16" data-id="element-195">
            <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 flex items-center shadow-sm hover:shadow-md transition-shadow" data-id="element-196">
              <span className="text-[#D4A853] text-xl mr-4" data-id="element-197">•</span>
              <span className="font-medium text-[#1B4332] text-lg" data-id="element-198">
                cocinar rápido
              </span>
            </div>
            <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 flex items-center shadow-sm hover:shadow-md transition-shadow" data-id="element-199">
              <span className="text-[#D4A853] text-xl mr-4" data-id="element-200">•</span>
              <span className="font-medium text-[#1B4332] text-lg" data-id="element-201">
                reducir calorías sin perder sabor
              </span>
            </div>
            <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 flex items-center shadow-sm hover:shadow-md transition-shadow" data-id="element-202">
              <span className="text-[#D4A853] text-xl mr-4" data-id="element-203">•</span>
              <span className="font-medium text-[#1B4332] text-lg" data-id="element-204">
                organizar tus comidas
              </span>
            </div>
            <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 flex items-center shadow-sm hover:shadow-md transition-shadow" data-id="element-205">
              <span className="text-[#D4A853] text-xl mr-4" data-id="element-206">•</span>
              <span className="font-medium text-[#1B4332] text-lg" data-id="element-207">
                mantener hábitos sostenibles
              </span>
            </div>
          </div>

          <p className="text-xl text-[#2D5016]/80 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-208">
            Todo utilizando una herramienta que ya millones de personas tienen
            en casa:
          </p>

          <p className="text-5xl md:text-6xl font-bold text-[#D4A853] italic mb-12 drop-shadow-sm" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-209">
            la Airfryer
          </p>

          <div className="bg-[#F5F0E8] border-l-4 border-[#D4A853] p-8 mb-12 text-left max-w-3xl mx-auto rounded-r-2xl shadow-sm" data-id="element-210">
            <p className="text-lg md:text-xl text-[#1B4332] font-medium leading-relaxed" data-id="element-211">
              La cocción con aire caliente permite reducir hasta 70-80% del
              aceite comparado con frituras tradicionales.
            </p>
          </div>

          <p className="text-2xl font-bold text-[#1B4332] mb-8" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-212">
            Esto significa:
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-10 mb-16 text-lg font-medium text-[#1B4332]" data-id="element-213">
            <span className="flex items-center gap-3" data-id="element-214">
              <span className="text-[#D4A853] text-xl" data-id="element-215">•</span> menos calorías
            </span>
            <span className="flex items-center gap-3" data-id="element-216">
              <span className="text-[#D4A853] text-xl" data-id="element-217">•</span> menos grasas
            </span>
            <span className="flex items-center gap-3" data-id="element-218">
              <span className="text-[#D4A853] text-xl" data-id="element-219">•</span> más facilidad
              para mantener una alimentación saludable
            </span>
          </div>

          <div className="bg-[#1B4332] text-[#FAF7F2] rounded-3xl p-10 md:p-14 shadow-2xl mb-16 relative overflow-hidden" data-id="element-220">
            {/* Decorative element inside the dark box */}
            <h3 className="text-3xl md:text-4xl font-bold mb-10 text-[#D4A853]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-221">
              Cómo funciona el sistema
            </h3>

            <div className="space-y-6 text-xl md:text-2xl text-left max-w-md mx-auto font-medium text-[#FAF7F2]/90" data-id="element-222">
              <p className="flex items-center gap-6" data-id="element-223">
                <span className="text-3xl text-[#D4A853]" data-id="element-224">1.</span> Abres el
                material
              </p>
              <p className="flex items-center gap-6" data-id="element-225">
                <span className="text-3xl text-[#D4A853]" data-id="element-226">2.</span> eliges la
                receta o el plan semanal
              </p>
              <p className="flex items-center gap-6" data-id="element-227">
                <span className="text-3xl text-[#D4A853]" data-id="element-228">3.</span> cocinas en
                minutos
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-[#D4A853]/20 text-lg md:text-xl text-[#FAF7F2]/70 space-y-3" data-id="element-229">
              <p data-id="element-230">Sin dietas extremas.</p>
              <p data-id="element-231">Sin pasar horas en la cocina.</p>
              <p data-id="element-232">Sin sentir que estás "a dieta".</p>
            </div>
          </div>

          <CTAButton href="#compra" text="SÍ, QUIERO EMPEZAR A ADELGAZAR HOY" data-id="element-233" />
        </FadeInView>
      </div>
    </section>;
}